import { Component , CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Router, ActivatedRoute, RouterModule } from "@angular/router";
import { ICountryWorkflowConfigurationStatus } from "../../../interfaces/icountryworkflowconfigurationstatus";
import { ArrayPropertyFilterPipe } from "../../../pipes/arrayproperty.pipe";

@Component({
    selector: "workflowcountries",
    standalone: true,
    imports: [CommonModule, FormsModule, RouterModule, ArrayPropertyFilterPipe],
    templateUrl: "./workflowcountries.component.html",
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class WorkflowCountriesComponent {
    countryConfig: ICountryWorkflowConfigurationStatus[];
    defaultConfig: ICountryWorkflowConfigurationStatus;
    searchTerm: string;

    constructor(private router: Router, private activatedRoute: ActivatedRoute) {
        this.countryConfig = this.activatedRoute.snapshot.data["workflowCountries"] as ICountryWorkflowConfigurationStatus[];

        // always expect atleast one default
        this.defaultConfig = this.countryConfig.filter(e => e.name.indexOf("Default") > -1)[0];
        this.countryConfig = this.countryConfig.filter(e => e.name.indexOf("Default") < 0);
    }

    workflowClicked(item: ICountryWorkflowConfigurationStatus): void {
        const countryCode: string = item.countryCode ? item.countryCode : "DEFAULT";

        this.router.navigate([`/workflow/${item.name}/${countryCode}`]);
    }
}

